(ns common.schema.entities.reminder-rule.options
  (:require
   [clojure.string :as string]))

(def reminder-anchor-options
  [{:key :reminder-anchor/cycle-end
    :label "Cycle end"}
   {:key :reminder-anchor/batch-send
    :label "Batch send"}
   {:key :reminder-anchor/deadline
    :label "Deadline"}
   {:key :reminder-anchor/previous-reminder
    :label "Previous reminder"}])

(def offset-direction-options
  [{:key :offset.direction/before
    :label "Before"}
   {:key :offset.direction/after
    :label "After"}])

(defn default-offset-direction
  "Which way a reminder normally sits relative to its anchor.

   A deadline or a cycle end is something you remind people ahead of, so those
   default to Before. A batch send and a previous reminder are events that have
   already happened, so the only sensible follow-up is After."
  [reminder-anchor]
  (case reminder-anchor
    :reminder-anchor/batch-send        :offset.direction/after
    :reminder-anchor/previous-reminder :offset.direction/after
    :offset.direction/before))

(def offset-type-options
  [{:key :offset.type/minutes
    :label "Minutes"}
   {:key :offset.type/hours
    :label "Hours"}
   {:key :offset.type/days
    :label "Days"}
   {:key :offset.type/weeks
    :label "Weeks"}])

(def reminder-rule-status-options
  [{:key :reminder-rule.status/draft
    :label "Draft"}
   {:key :reminder-rule.status/active
    :label "Active"}
   {:key :reminder-rule.status/archived
    :label "Archived"}])

(defn option-label
  [options k]
  (or (some->> options
               (filter (fn [option] (= (:key option) k)))
               (first)
               :label)
      (some-> k name)))

(defn offset-text
  "\"2 Days before\" rather than \"-2 Days\".

   A rule written before the direction field existed has none and carries its
   direction in the sign of the value, so those render as they are rather than
   being given a direction they never declared."
  [{:keys [offset-value offset-type offset-direction]}]
  (let [value (or offset-value 0)
        type-label (option-label offset-type-options offset-type)]
    (if offset-direction
      (str (abs value)
           " "
           type-label
           " "
           (string/lower-case
            (option-label offset-direction-options offset-direction)))
      (str value " " type-label))))

(defn schedule-text
  "How a rule is actually scheduled, as \"Deadline · 2 Days before\".

   The rule's label is free text and nothing keeps it honest - the local QA
   tenant has a \"Day of dealine\" that fires two days early and a \"2 weeks
   before deadline\" that is really one day after the previous reminder. So
   anywhere a label is shown to someone making a decision, this goes with it."
  [{:keys [reminder-anchor] :as reminder-rule}]
  (str (option-label reminder-anchor-options reminder-anchor)
       " · "
       (offset-text reminder-rule)))
